/**
 * Sanitizes user input to prevent XSS attacks
 */
export const sanitizeInput = (input: string): string => {
  if (typeof input !== 'string') return '';
  
  return input
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;')
    .trim();
};

/**
 * Validates email format
 */
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Validates name (only letters, spaces, and common characters)
 */
export const validateName = (name: string): boolean => {
  const nameRegex = /^[a-zA-ZÀ-ÿ\s'-]{2,50}$/;
  return nameRegex.test(name);
};

/**
 * Sanitizes and validates user input for forms
 */
export const sanitizeAndValidateFormData = (data: Record<string, any>) => {
  const sanitized: Record<string, any> = {};
  const errors: Record<string, string> = {};

  Object.keys(data).forEach(key => {
    const value = data[key];
    
    if (typeof value === 'string') {
      sanitized[key] = sanitizeInput(value);
      
      // Specific validations
      if (key === 'email' && !validateEmail(sanitized[key])) {
        errors[key] = 'Email inválido';
      }
      
      if ((key === 'fullName' || key === 'nome') && !validateName(sanitized[key])) {
        errors[key] = 'Nome deve conter apenas letras e espaços';
      }
      
      // Required field validation
      if (!sanitized[key] && key !== 'confirmPassword') {
        errors[key] = 'Campo obrigatório';
      }
    } else {
      sanitized[key] = value;
    }
  });

  return { sanitized, errors, isValid: Object.keys(errors).length === 0 };
};